/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosButton from "../../../../../components/Buttons/ArgosButton";
import ArgosDialogHeader from "../../../../../components/Dialogs/ArgosDialogHeader";
import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox";
import React from "react";
import ReportView from "./ReportView";
import Typography from "@mui/material/Typography";
import {setIsReportDialogOpen} from "../../../../../../redux/ducks/VehicleProgramsDetails/slice";
import {useAppDispatch} from "../../../../../../redux/hooks";
import CloseIcon from '@mui/icons-material/Close';
import {IconButton} from "@mui/material";

const ReportDialog = React.memo((props: any) => {
  const dispatch = useAppDispatch()

  const onClickClose = () => {
    dispatch(setIsReportDialogOpen(false))
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', height: "100%"}}>
      <div style={{}}>
        <ArgosDialogHeader>
          <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
            <Typography sx={{color: 'white', fontSize: 14, textAlign: 'left'}}>
              Report View
            </Typography>
            <IconButton onClick={onClickClose} sx={{color: 'white', padding: 0, fontSize: 'small'}}>
              <CloseIcon/>
            </IconButton>
          </ArgosFlexbox>
        </ArgosDialogHeader>
      </div>

      <div style={{flex: 1, overflow: 'auto', padding: 0}}>
        <ReportView/>
      </div>

      <ArgosFlexbox style={{alignItems: "center", alignSelf: "center", gap: 10, padding: 15}}>
        <ArgosButton
          onClick={onClickClose}
        >
          Cancel
        </ArgosButton>
      </ArgosFlexbox>
    </div>
  )
})

export default ReportDialog
